/** Routes où le launcher Intercom est masqué (flows sensibles, onboarding, formulaires). */
export const INTERCOM_HIDDEN_ROUTES = [
  '/sign-on',
  '/signup/company',
  '/forgot-password',
  '/reset-password',
  '/auth/callback',
  '/company-onboarding',
  '/onboarding',
  '/onboarding/freelancer',
  '/onboarding/verify',
  '/missions/create',
  '/activity-report/create',
] as const

/** Routes publiques où Intercom est affiché en mode visiteur (sans JWT). */
export const INTERCOM_VISITOR_ROUTES = ['/login'] as const

export function shouldHideIntercom(pathname: string): boolean {
  return INTERCOM_HIDDEN_ROUTES.some((route) => pathname.startsWith(route))
}

export function isIntercomVisitorRoute(pathname: string): boolean {
  return INTERCOM_VISITOR_ROUTES.some((route) => pathname.startsWith(route))
}
